import axios from 'axios';

const GetPackagesList = (count, page) => {
	return axios.get(
		'https://backend.planmyleisure.com/package/get-packages'
	);
};

export default GetPackagesList;
